import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'banking-root',
  template: `<router-outlet></router-outlet>`,
  styles: [`@import url(https://firebasestorage.googleapis.com/v0/b/rbs-marketplace-p.appspot.com/o/theming%2Fconnect.css?alt=media&token=13c7a06f-89a3-4573-ae23-7968dd0af37a);body{background-color:#443060}`],
  encapsulation: ViewEncapsulation.None
})
export class BankingComponent {
}
